import { Box, Card, CardActionArea, CardContent, Grid, IconButton, Typography } from '@mui/material'
import React from 'react'
import FacebookIcon from '@mui/icons-material/Facebook';
import RedditIcon from '@mui/icons-material/Reddit';
import InstagramIcon from '@mui/icons-material/Instagram';
import { useNavigate } from 'react-router-dom';
import SettingsManage from './SettingsManage';
import YouTubeIcon from '@mui/icons-material/YouTube';

const SettingsLayout = () => {
    const [selectedCard, setSelectedCard] = React.useState(null);
    const navigate = useNavigate()

    const cards = [
      
        {
            id: 3,
            title: 'Instagram Accounts',
            icon: <InstagramIcon color='primary' />,
            link: "/instagram",
            description: 'Manage instagram setings',
        },
        {
            id: 2,
            title: 'Facebook Accounts',
            icon: <FacebookIcon color='primary' />,
            link: "/facebook",
            description: 'Manage facebook setings',
        },
          {
            id: 1,
            title: "YouTube Accounts",
            icon: <YouTubeIcon color='primary'/>,
            link:"/youtube",
            description: 'Manage youtube settings',
        },
          {
            id: 4,
            title: "Reddit Accounts",
            icon: <RedditIcon color='primary'/>,
            link:"/reddit",
            description: 'Manage reddit settings',
        },

    ];
    return (
        <Box>
            <Grid container spacing={2} >
                {cards.map((card, index) => (
                    <Grid item lg={3} md={3} sm={12} xs={12} key={index}>
                        <Card onClick={() => { navigate("/settings" + card.link) }}>
                            <CardActionArea
                                onClick={() => setSelectedCard(index)}
                                data-active={selectedCard === index ? '' : undefined}
                                sx={{
                                    height: '100%',
                                    '&[data-active]': {
                                        backgroundColor: 'action.selected',
                                        border: "1px solid #e2edcc",
                                        '&:hover': {
                                            backgroundColor: 'action.selectedHover',
                                        },
                                    },
                                }}
                            >
                                <CardContent className='settings-card' >
                                    <IconButton>{card.icon}</IconButton>
                                    <Box>
                                        <Typography variant="Body1" component="div" color='primary'>
                                            {card.title}
                                        </Typography>
                                    </Box>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                ))}
            </Grid>
            <SettingsManage />
        </Box>
    )
}

export default SettingsLayout